import { PersonalInfo, Skill, NavLink } from '../types';

export const personalInfo: PersonalInfo = {
  name: "Sohail Mohammad",
  title: "Senior AI Engineer",
  subtitle: "Engineer–Designer–Strategist. I turn complexity into leverage, one system at a time",
  description: "Playful Ambition. Disciplined Execution.",
  email: "sohailmo.ai@gmail.com",
  github: "https://github.com/sohailm25",
  linkedin: "https://www.linkedin.com/in/sohail-mo/",
  twitter: ""
};

export const aboutMe = {
  paragraphs: [
    "I architect and scale production AI systems that bridge frontier technology with enterprise reality - from LLM platforms processing hundreds of thousands of financial queries at JPMorgan to distributed ML infrastructures that power critical business decisions in retail environments",
    "In an era where every company wants AI but few can operationalize it, I bring the rare combination of production ML expertise, distributed systems architecture, and business acumen needed to deliver AI that actually ships. My work spans the complete spectrum from infrastructure provisioning to LLM optimization to cross-functional strategy, always focused on systems that compound value over time"
  ]
};

export const skills: Skill[] = [
  {
    category: "AI/ML & LLMs",
    items: [
      {
        name: "PyTorch",
        description: "Deep learning model development, fine-tuning, and deployment. Experience with transformers, computer vision, and distributed training.",
        experience: "4+ years",
        projects: ["LLM Platform Architecture", "Vision Models", "Multi-Modal RAG Systems"]
      },
      {
        name: "LangChain",
        description: "Building sophisticated LLM applications with RAG, agent orchestration, and tool integration for production systems.",
        experience: "2+ years",
        projects: ["Enterprise Chatbot Platform", "Document Intelligence System", "Multi-Agent Workflows"]
      },
      {
        name: "Hugging Face",
        description: "Model fine-tuning, deployment, and optimization. Experience with Transformers, Datasets, and model hosting.",
        experience: "3+ years",
        projects: ["Custom LLM Fine-tuning", "Model Deployment Pipeline"]
      },
      "OpenAI APIs",
      "Claude/Anthropic",
      "Vector Databases (Pinecone, Weaviate)",
      "MLflow"
    ]
  },
  {
    category: "Backend & Infrastructure",
    items: [
      {
        name: "Python",
        description: "Production ML systems, async programming, FastAPI services, and distributed computing with extensive library ecosystem.",
        experience: "6+ years",
        projects: ["ML Platform", "Async Services", "Data Pipelines"]
      },
      {
        name: "AWS",
        description: "Full-stack cloud architecture with ECS, EKS, Lambda, SageMaker, and comprehensive data/ML services.",
        experience: "4+ years",
        projects: ["Serverless ML APIs", "Container Orchestration", "Data Lake Architecture"]
      },
      {
        name: "Docker & Kubernetes",
        description: "Containerization and orchestration of ML workloads, microservices, and distributed systems at scale.",
        experience: "4+ years",
        projects: ["ML Model Serving", "Microservices Platform"]
      },
      "FastAPI",
      "Redis",
      "PostgreSQL",
      "MongoDB",
      "GraphQL"
    ]
  },
  {
    category: "Data Engineering",
    items: [
      {
        name: "Apache Spark",
        description: "Large-scale data processing, ETL pipelines, and distributed computing for ML feature engineering.",
        experience: "3+ years",
        projects: ["Real-time Analytics", "Feature Store", "Data Lake Processing"]
      },
      {
        name: "Airflow",
        description: "Workflow orchestration for complex ML pipelines, data processing, and scheduled jobs.",
        experience: "2+ years",
        projects: ["ML Training Pipelines", "ETL Orchestration"]
      },
      "Databricks",
      "Snowflake",
      "dbt",
      "Kafka"
    ]
  },
  {
    category: "Frontend & Visualization",
    items: [
      {
        name: "React & TypeScript",
        description: "Modern web applications with type safety, state management, and component architecture.",
        experience: "3+ years",
        projects: ["AI Dashboard", "Real-time Monitoring", "Interactive ML Tools"]
      },
      {
        name: "Chainlit",
        description: "Rapid prototyping of ML demos, dashboards, and interactive data applications.",
        experience: "2+ years",
        projects: ["LLM Demo Apps", "Model Evaluation Tools"]
      },
      "Next.js",
      "Tailwind CSS",
      "D3.js",
      "Plotly"
    ]
  }
];

export const navLinks: NavLink[] = [
  { href: "#home", label: "Home" },
  { href: "#about", label: "About" },
  { href: "#projects", label: "Projects" },
  { href: "#blog", label: "Blog" },
  { href: "#contact", label: "Contact" }
];
